import { createInvite as publicCreateInvite } from './identity-invites-v1-account-invite-account-invites.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const createInvite: MaybeContext<
  BuildRESTFunction<typeof publicCreateInvite> & typeof publicCreateInvite
> = /*#__PURE__*/ createRESTModule(publicCreateInvite);

export {
  InviteStatus,
  SimpleConditionOperator,
  JoinedConditionOperator,
  SubjectType,
  SubjectContextType,
} from './identity-invites-v1-account-invite-account-invites.universal.js';
export {
  AccountInvite,
  InviteResourceAssignment,
  InviteAssignment,
  FullNameResource,
  FullNameResourceResourceContextOneOf,
  SiteResourceContext,
  AccountResourceContext,
  OrganizationResourceContext,
  Resource,
  PolicyCondition,
  ConditionType,
  ConditionTypeOfOneOf,
  SimpleCondition,
  SimpleConditionValue,
  SimpleConditionValueValueOneOf,
  JoinedCondition,
  EnvironmentCondition,
  EnvironmentConditionConditionOneOf,
  ExperimentCondition,
  Condition,
  ConditionOperator,
  ConditionOperatorOperatorsOneOf,
  EqualOperator,
  ConditionValue,
  ConditionValueValueOneOf,
  LikeOperator,
  ExperimentOperator,
  DependOnOperator,
  Subject,
  SubjectContext,
  GetAccountInvitesRequest,
  GetAccountInvitesResponse,
  GetAccountInviteRequest,
  GetAccountInviteResponse,
  AccountInviteRequest,
  AccountInviteResponse,
  CreateInviteRequest,
  SubjectInviteAssignments,
  CreateInviteResponse,
  InviteFailure,
  BulkAccountInviteRequest,
  BulkAccountInviteResponse,
  ResendAccountInviteRequest,
  AcceptAccountInviteRequest,
  AcceptAccountInviteResponse,
  RevokeAccountInviteRequest,
  RevokeAccountInviteResponse,
  UpdateAccountInviteRequest,
  UpdateAccountInviteResponse,
  UpdateAccountInviteAssignmentsRequest,
  UpdateAccountInviteAssignmentsResponse,
  ParseAccountInviteTokenRequest,
  ParseAccountInviteTokenResponse,
  CreateInviteOptions,
} from './identity-invites-v1-account-invite-account-invites.universal.js';
export {
  InviteStatusWithLiterals,
  SimpleConditionOperatorWithLiterals,
  JoinedConditionOperatorWithLiterals,
  SubjectTypeWithLiterals,
  SubjectContextTypeWithLiterals,
} from './identity-invites-v1-account-invite-account-invites.universal.js';
